<template>
  <div
    v-select-test-parts
    :data-testid="selectTestId('select')"
  >
    <v-autocomplete
      ref="endpoint"
      dense
      prepend-inner-icon="far fa-search"
      :value="selectedEndpoint"
      :label="$t('EndpointName') + (required ? ' *' : '')"
      :items="ec.items"
      item-text="endpointName"
      item-value="endpointId"
      clearable
      class="hd-autocomplete"
      :rules="required ? [v => !!v || $t('RequiredField')] : []"
    >
      <template #selection="{ item }">
        <div class="ml-2">
          {{ item.endpointName }}
        </div>
      </template>
      <template #item="{ item }">
        <div
          class="ml-2"
          :data-testid="selectTestId('option', item.endpointId)"
        >
          {{ item.endpointName }}
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { EndpointCollection } from '../../../model/endpoint/EndpointCollection'
import { testIdFor, selectTestParts } from '../../../util/testId'
export default {
  name: 'HdEndpointSelector',
  directives: { selectTestParts },

  props: {
    companyId: {
      required: true,
      type: Number
    },
    selectedEndpoint: {
      required: false,
      type: Number,
      default() { 
        return null
      }
    },
    required: {
      required: false,
      type: Boolean,
      default() {
        return false
      }
    },
    /**
     * Base data-testid: the select gets '<testId>-select', options '<testId>-option-<endpointId>'
     */
    testId: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      ec: new EndpointCollection({companyId: this.companyId}),
      selection: null
    }
  },
  mounted() {    
    this.ec.pageSize = 400
    this.ec.fetch()
  },
  methods: {
    selectTestId(...parts) {
      return testIdFor(this.testId, ...parts)
    },
    getValue() {
      let endpoint = this.$refs.endpoint.internalValue      
      return endpoint > 0 ? endpoint : null
    },
  }
}

</script>
